import {trackBtnClick} from '@/store/api/trackBtnClick';
import getPkce from 'oauth-pkce';
import {APIService} from './api.service';
// import {getParameterByName} from './auth-shared';

const CLIENT_ID = process.env.VUE_APP_AMEX_CLIENT_ID;
const CLIENT_DOMAIN = process.env.VUE_APP_AMEX_DOMAIN;
const SCOPE = 'openid';
const REDIRECT = process.env.VUE_APP_AUTH0_CALLBACK_URL;
const VERIFIER = 'amex_token_verifier';

export function amexLogin() {
  getPkce(43, (error, {verifier, challenge}) => {
    if (!error) {
      localStorage.setItem(VERIFIER, verifier);
      const url = `${CLIENT_DOMAIN || ''}?client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(
        REDIRECT,
      )}&scope=${SCOPE}&code_challenge=${challenge}&code_challenge_method=S256&state=OxeRadQjHa86ahFg&nonce=1kuzB5aUvTM`;
      trackBtnClick('', url);
      window.location.href = url;
    }
  });
}

export async function getAmexAuthToken() {
  const verifier = localStorage.getItem(VERIFIER);
  const url = new URL(window.location.toString());
  const code = url.searchParams.get('authCode');
  return APIService.get('oauth/token/bearer', {
    params: {
      code,
      code_verifier: verifier,
      redirect_uri: REDIRECT,
      mode: process.env.VUE_APP_MODE,
    },
  });
}

export * from './auth-shared';
